/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { PLACEHOLDER_KEY } from '../../wireframes/WireframeBase';
import { InputField, type InputFieldProps } from './InputField';

type PlaceholderProps = Omit<InputFieldProps, 'textKey' | 'item' | 'onChange'>;

export const Placeholder: CanvaSXFC<PlaceholderProps> = function (props) {
  const { wireframe } = props;
  const { placeholder } = wireframe;

  return (
    <InputField
      textKey={PLACEHOLDER_KEY}
      item={placeholder}
      onChange={value => wireframe.setPlaceholderValue(value)}
      {...props}
    />
  );
};
